import React, { useEffect, useState } from 'react';

import './PaymentTime.scss';
import Message from '../../../../components/shared/Message';
import Translation from '../../../../services/translation.service';
import PaymentService from '../../../../services/payment.service';
import { TRANSACTION_ID, ORDER_ID, LOCAL_STORAGE } from '../../../../constants';
import {
  getStorageElement,
  removeStorageElement,
} from '../../../../services/storage.service';
import { getQueries, handleError } from '../../../../util';
import Spinner from '../../../../components/shared/Spinner';
import HyperPayPayment from '../../../../components/shared/HyperPayPayment';

function PaymentTime(props) {
  const [loading, updateLoading] = useState(false);
  const [onComplete, updateOnComplete] = useState(false);
  const [result, updateResult] = useState(null);
  const authId = getQueries('id');
  const authOrderId = getQueries('orderId');
  const tabbyPaymentId = getQueries('payment_id');
  let orderIDtmp = getStorageElement(ORDER_ID, LOCAL_STORAGE);

  const actionAfterPayment = React.useCallback(() => {
    removeStorageElement('transaction_id', 'local');
  }, []);

  useEffect(() => {
    if (authId || authOrderId || tabbyPaymentId) {
      updateOnComplete(true);
      let transactionID = getStorageElement(TRANSACTION_ID, 'local');
      let authObject = {
        id: authId ?? authOrderId ?? tabbyPaymentId,
      };
      let result = {};
      updateLoading(true);
      PaymentService.commitPayment(transactionID, authObject)
        .then(() => {
          updateOnComplete(true);
          result = {
            success: true,
            message: `The order has successfully completed, your order number is ${orderIDtmp}.`,
            action: actionAfterPayment,
          };
          updateResult(result);
          updateLoading(false);
        })
        .catch((error) => {
          // const errorMsg = handleError(error);
          const errorMsg = Translation.key(
            error?.response?.data?.messageKey ?? 'generic_paymnt_error_msg'
          );
          result = {
            success: false,
            message: errorMsg,
            btnLabel: Translation.key('generic_error_btn_try_again'),
            action: actionAfterPayment,
          };
          updateResult(result);
          updateLoading(false);
          updateOnComplete(true);
        });
    }
  }, [authId, authOrderId, tabbyPaymentId]);

  const getRedirect = () => {
    return window.location.href;
  };

  return (
    <>
      <div className="payment-container">
        {!onComplete && (
          <>
            <h1>{Translation.key('b2b_payment_time')}</h1>
            <HyperPayPayment
              redirect={getRedirect()}
              source={'m2m-order'}
              externalId={props.orderID.toString()}
            />
          </>
        )}
        {result && (
          <div className="message-area">
            <Message
              action={result.action}
              success={result.success}
              message={result.message}
              btnLabel={result.btnLabel}
            ></Message>
          </div>
        )}

        {loading && <Spinner />}
      </div>
    </>
  );
}

export default PaymentTime;
